<ion-button
  *ngIf="type == 'button'; else tabs"
  (click)="socialMedia('whatsapp')"
  expand="full"
  color="success"
  style="width: 100%"
  [disabled]="!waText"
>
  Abrir Whatsapp
</ion-button>

<ng-template #tabs>
  <ion-toolbar color="light" style="margin-bottom: -4px">
    <ion-row>
      <ion-col size="4" class="ion-align-self-center">
        <ion-tab-button
          (click)="socialMedia('whatsapp')"
          [disabled]="!this.waPhone"
        >
          <ion-icon name="paper-plane-outline" color="secondary"></ion-icon>
          <ion-label
            style="
              margin-top: 5px;
              font-weight: bold;
              font-size: 10px;
              color: black;
            "
            >Contacto</ion-label
          >
        </ion-tab-button>
      </ion-col>
      <ion-col
        size="4"
        class="ion-align-self-center"
        style="display: flex; justify-content: center"
      >
        <ion-tab-button (click)="openAbout('terms')" class="avatar-button">
          <ion-avatar *ngIf="isGeneralVersion">
            <img src="./assets/logowhite-simple.png" />
          </ion-avatar>
          <ion-avatar *ngIf="!isGeneralVersion">
            <img src="./assets/logoblack-simple.png" />
          </ion-avatar>
        </ion-tab-button>
      </ion-col>
      <ion-col size="4" class="ion-align-self-center">
        <ion-tab-button (click)="socialMedia('instagram')">
          <ion-icon name="logo-instagram" color="secondary"></ion-icon>
          <ion-label
            style="
              margin-top: 5px;
              font-weight: bold;
              font-size: 10px;
              color: black;
            "
            >Instagram</ion-label
          >
        </ion-tab-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
  <ion-toolbar color="light">
    <ion-row>
      <ion-col
        size="12"
        class="ion-align-self-center"
        style="display: flex; justify-content: center"
      >
        <ion-button
          size="small"
          color="secondary"
          shape="round"
          style="font-size: 10px"
          (click)="openVideo()"
          [disabled]="!videoUrl ? true : false"
        >
          Conoce mas
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ng-template>
